import React from 'react';
import { Row, Col, Container } from 'react-grid-system';
import '../Assests/player.css';
import youtube from '../Assests/images/youtube.png';
import ReactPlayer from "react-player";

function Player() {
  return (
    <Container>
        <Row>
            <Col >
            <img className="imgLogo" src={youtube} alt=""/>
            </Col>
        </Row>
        <Row className="playerow">
            <Col xs sm={12} md lg={4}>
            
      <ReactPlayer
        url="https://www.youtube.com/watch?v=pTfD4za1304"
          width='90%'
          height='100%'

      />
    
      </Col>
      <Col xs sm={12} md lg={4}>
      <ReactPlayer
        url="https://www.youtube.com/watch?v=e8DsWN7JJxs"
          width='90%'
          height='100%'

      />

      
      </Col>
      <Col xs sm={12} md lg={4}>
      <ReactPlayer
        url="https://www.youtube.com/watch?v=x7vMnylQlq4"
          width='90%'
          height='100%'

      />
      </Col>
     
      </Row>
      <Row className="playerow">
            <Col xs sm={12} md lg={4}>
            
      <ReactPlayer
        url="https://www.youtube.com/watch?v=qdGPUbpZpzI"
          width='90%'
          height='100%'

      />
    
      </Col>
      <Col xs sm={12} md lg={4}>
            
            <ReactPlayer
              url="https://www.youtube.com/watch?v=9Etm092iOpY"
                width='90%'
                height='100%'
      
            />
          
            </Col>
            <Col xs sm={12} md lg={4}>
            <ReactPlayer
              url="https://www.youtube.com/watch?v=-gkvvPj7f3w"
                width='90%'
                height='100%'
      
            />
      
            
            </Col>
     
      </Row>
      <Row>
        <Col xs sm={12} md lg={4}></Col>
        <Col xs sm={12} md lg={4}> </Col>
        <Col xs sm={12} md lg={4} className="btn">
        <a href="https://www.youtube.com/channel/UCbRU-vNWeBuRqK43FbQagiQ/videos"><button class="cybr-btn">
          See More
         <span aria-hidden class="cybr-btn__glitch"></span>
        </button></a>
        </Col>
      </Row>
    </Container>
  )
}

export default Player